import { jsx as l } from "react/jsx-runtime";
import { components as u } from "react-select";
import { MultiValueMoreTooltipContent as s, MultiValueMore as f } from "./styles.js";
import { Tooltip as c } from "../Tooltip/Tooltip.js";
const d = (i) => {
  const {
    index: r,
    getValue: n,
    selectProps: { maxSelectedValuesVisible: a = 1 / 0 }
  } = i, t = Math.max(a, 1);
  if (r < t)
    return /* @__PURE__ */ l(u.MultiValue, { ...i });
  if (r === t) {
    const o = n().slice(t).flatMap((e) => e && typeof e == "object" && "label" in e && typeof e.label == "string" ? e.label : []);
    return /* @__PURE__ */ l(
      c,
      {
        positioning: "fixed",
        tooltip: /* @__PURE__ */ l(s, { children: o.join(", ") }),
        children: /* @__PURE__ */ l(f, { children: `+${o.length} more` })
      }
    );
  }
  return null;
};
export {
  d as MultiValue
};
//# sourceMappingURL=MultiValue.js.map
